'use strict';

/**
 *
 * @name: nnMainNavigation
 *
 */

import DirectiveTemplate from './nn-main-navigation.directive.html';
import './nn-main-navigation.directive.scss';

function NnMainNavigationDirective() {

  'ngInject';

  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: DirectiveTemplate,
    controller: nnMainNavigationDirectiveController,
    controllerAs: 'mainnav'
  };
}

function nnMainNavigationDirectiveController(
  $rootScope,
  $translate,
  $location,
  $state,
  $timeout,
  $scope,
  $element
) {

  'ngInject';

  /**
   *
   * @CONFIG
   *
   */

  /*jshint validthis: true */
  var mainnav = this;
  mainnav.stateName = '';
  $scope.sites = {
    english: {
      'en-us': '.COM',
      'zh-cn': 'English',
      'zh-hk': '.COM',
    },
    chineese: {
      'en-us': '.CN',
      'zh-cn': '中文',
      'zh-hk': '.CN',
    },
    hongkong: {
      'en-us': '.ASIA',
      'zh-cn': '香港',
      'zh-hk': '.ASIA',
    },
  }

  /**
   *
   * @PUBLIC_METHODS
   *
   */

  mainnav.setLanguage = function(lang) {
    let tlDomain = ''
    let newLocation = ''

    if (lang === 'zh-cn') {
      tlDomain = 'cn';
    } else if (lang === 'en-us') {
      tlDomain = 'com';
    } else if (lang === 'zh-hk') {
      tlDomain = 'asia';
    }

    if ((window.location.hostname === 'localhost' || window.location.hostname.indexOf('herokuapp') > -1 || window.location.hostname.indexOf('airnauts') > -1 )) {
      newLocation = window.location.protocol + `//${window.location.hostname}:` + window.location.port + window.location.hash + '?devLang=' + lang
    } else if (window.location.hostname !== 'localhost') {
      // const splittedHostname = window.location.hostname.split('.')
      // const hostWithoutTlDomain = splittedHostname.slice(0, splittedHostname.length - 1).join('.')
      // newLocation = window.location.protocol + `//${window.location.host}` + window.location.hash + '?devLang=' + lang
      newLocation = `https://nowness.${tlDomain}/`
    }

    window.location.href = newLocation
  };

  /**
   *
   * @PRIVATE_METHODS
   *
   */


  function _updateStateName() {

    $scope.$watch(function() {
      return $state.current.name;
    }, function(newVal) {
      $scope.stateName = newVal;
    });
  }

  function _watchMenuIsOpen() {

    $scope.$watch('showMenu.open', function(newValue) {

      var innerHeight = 0;

      if (newValue) {
        // && $(window).width() <= 600)
        $element.find('ul').each(function() {

          innerHeight += $(this).innerHeight();
        });

        $element.find('.scroll-box-inner').css('height', innerHeight + 250 + 'px');
      }
    });
  }

  /**
   *
   * @INIT
   *
   */

  ($rootScope.categoryList || []).forEach(function(item) {

    item.name = item.translations[$rootScope.lang].name;
  });

  _updateStateName();
  _watchMenuIsOpen();
}

export default NnMainNavigationDirective;



// WEBPACK FOOTER //
// ./app/components/nn-navigation/nn-main-navigation/nn-main-navigation.directive.js